
import { Vue, Component } from 'vue-property-decorator';
import lazyInject from '@/di';
import SupplyService from '@/services/supply.service';
import { CProcurementGoods } from '@/models/supply.model';

@Component
export default class PlatPurchaseOrderDetailModal extends Vue {
  visible = false;

  invoiceVisible = false;

  uploading = false;

  detail: any = {};

  productList: any[] = [];

  license: any = null;

  @lazyInject(SupplyService)
  supplyService!: SupplyService;

  payStatusMap: any = {
    0: '待请款',
    1: '已付款',
  };

  invoiceStatusMap: any = {
    0: '未开票',
    1: '已开票',
  };

  productColumns = [
    {
      title: '物料编码',
      dataIndex: 'commodityCode',
      key: 'commodityCode',
      width: '100',
      align: 'center',
    },
    {
      title: '产品名称',
      dataIndex: 'commodityName',
      key: 'commodityName',
      width: '100',

      align: 'center',
    },
    {
      title: '包装规格',
      dataIndex: 'packageSpec',
      key: 'packageSpec',
      width: '100',
      align: 'center',
    },
    {
      title: '数量/箱',
      dataIndex: 'perPackageNum',
      key: 'perPackageNum',
      width: '100',
      align: 'center',
    },
    {
      title: '升/壶',
      dataIndex: 'perUnitNum',
      key: 'perUnitNum',
      width: '100',
      align: 'center',
    },
    {
      title: '采购箱数',
      dataIndex: 'packageQuantity',
      key: 'packageQuantity',
      width: '100',
      align: 'center',
    },
    {
      title: '采购壶数',
      dataIndex: 'quantity',
      key: 'quantity',
      width: '100',
      align: 'center',
    },
    {
      title: '采购单价/壶',
      dataIndex: 'platPurchasePrice',
      key: 'platPurchasePrice',
      width: '100',
      align: 'center',
    },
    {
      title: '总金额',
      dataIndex: 'platPurchaseAmount',
      key: 'platPurchaseAmount',
      width: '100',
      align: 'center',
    },
  ];

  pagination: any = {
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: this.$store.state.pageSize.pageSize,
    onChange: this.paginationChange,
    onShowSizeChange: this.paginationChange,
  };

  scrollY = 300;

  async open(record: any) {
    // this.detail = record || {};
    const res = await this.supplyService.getPlatOrderDetail({ batch_no: record });
    this.detail = res;
    this.visible = true;
    this.pagination.current = 1;
    await this.getDetail();
    this.calcScrollY();
  }

  mounted() {
    window.addEventListener('resize', this.calcScrollY);
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.calcScrollY);
  }

  calcScrollY() {
    const offset = 450;
    this.scrollY = Math.max(window.innerHeight - offset, 200);
  }

  async getDetail() {
    // TODO: 调用平台采购单详情接口获取商品明细
    const res: any = await this.supplyService.getPurchaseOrderCommodities({
      batch_no: this.detail.batch_no,
      page: this.pagination.current,
      pageSize: this.pagination.pageSize,
    });
    this.productList = res.list.map(
      (item: any) => CProcurementGoods.from(item),
      // eslint-disable-next-line function-paren-newline
    );
    this.pagination.total = res.total || 0;
  }

  paginationChange(page: number, pageSize: number) {
    this.pagination.current = page;
    this.pagination.pageSize = pageSize;
    this.getDetail();
  }

  openInvoiceUpload() {
    this.invoiceVisible = true;
    this.license = null;
  }

  closeInvoiceUpload() {
    this.invoiceVisible = false;
    this.license = null;
  }

  handleInvoiceUpdate(val: any) {
    this.license = val;
  }

  async submitInvoice() {
    if (!this.license || !this.license.id) {
      this.$message.error('请先上传发票');
      return;
    }
    this.uploading = true;
    try {
      // TODO: 调用确认开票接口
      await this.supplyService.postUploadPlatInvoice({
        batch_no: this.detail.batchNo,
        license_id: this.license.id,
      });
      this.$message.success('确认开票成功');
      this.closeInvoiceUpload();
      this.onClose();
      this.$emit('refresh');
    } catch (e) {
      console.error(e);
    } finally {
      this.uploading = false;
    }
  }

  onClose() {
    this.visible = false;
    this.detail = {};
    this.pagination.current = 1;
    this.pagination.total = 0;
    this.pagination.pageSize = 10;
    this.productList = [];
  }
}
